<div class="preview-modal--container" wp-isolated-query-space *ngIf="workPackage">
 <wp-single-card [workPackage]="workPackage"
                 orientation="horizontal">
 </wp-single-card>
</div>
